import { Modal } from "reactstrap";
import styles from './NewProductForm.module.scss';
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { Field, Form } from "react-final-form";
import OutlinedFormInput from "../../Finance/components/OutlinedFormInput/OutlinedFormInput";
import { onBlurFormatNumber, parseNumberForDB } from "../../../components/functions/utilities";
import { useResponsive } from "../../../components/Hooks/useResponsive";
import { MdOutlineClose as CloseIcon } from 'react-icons/md';

type Props = {
    isOpen: boolean,
    onClose: () => void,
    handleAddNewProduct: (values: any) => void;
}

const NewProductForm = ({ isOpen, onClose, handleAddNewProduct }: Props) => {
    const { isMobile } = useResponsive();

    return (
        <>
            <Modal size='md' centered isOpen={isOpen} toggle={() => {
                onClose();
            }}>
                <div className={styles.formRootContainer}>
                    <div className={styles.headerContainer}>
                        <div className={styles.title}>
                            Add New Product
                        </div>
                        <div className={styles.btnContainer}>
                            <MeritoButton icon={<CloseIcon />} onlyIcon={true} type="tertiary" size="md" onClick={() => {
                                onClose();
                            }} />
                        </div>
                    </div>
                    <Form
                        onSubmit={(values) => {
                            console.log('values', values);
                            handleAddNewProduct({
                                ...values,
                                isNew: true,
                                productId: null,
                                dataSource: null,
                            });
                            onClose();
                            return {};
                        }}
                        render={({ values, handleSubmit, pristine, hasValidationErrors }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <div className={styles.formBodyContainer}>
                                        <Field validate={(value) => {
                                            if (!value) {
                                                return `Enter product name`
                                            }
                                        }} name="productName">
                                            {(props) => {
                                                return (
                                                    <OutlinedFormInput
                                                        {...props.input}
                                                        label="Product Name"
                                                        name={props.input.name}
                                                        value={props.input.value}
                                                        onChange={props.input.onChange}
                                                        error={props.meta.error}
                                                        touched={props.meta.touched}
                                                        maxLength={300}
                                                    />
                                                )
                                            }}
                                        </Field>

                                        <Field name="unitsPurchased"
                                            validate={(value) => {
                                                if (!value) {
                                                    return `Enter no. of units purchased from the supplier`
                                                }
                                            }}>
                                            {(props) => (
                                                <OutlinedFormInput
                                                    {...props.input}
                                                    label="Units Purchased"
                                                    showError={true}
                                                    placeholder="Number of Units Purchased From the Supplier"
                                                    inpuType="number"
                                                    name={props.input.name}
                                                    value={props.input.value}
                                                    onChange={(e) => {
                                                        const numericValue = parseNumberForDB(e.target.value, false);
                                                        // console.log('numeric value', numericValue)
                                                        props.input.onChange(numericValue);
                                                    }}
                                                    error={props.meta.error}
                                                    touched={props.meta.touched}
                                                    onBlur={(e) => {
                                                        const value = props.input.value;
                                                        // console.log('value', value);
                                                        const formattedValue = onBlurFormatNumber(value, 0);
                                                        props.input.onChange(formattedValue);
                                                        // console.log('inputValue', value)
                                                        props.input.onBlur(e);
                                                    }}
                                                    maxLength={21}
                                                    isCurrency={false}
                                                />
                                            )}
                                        </Field>

                                        <Field name="amount"
                                            validate={(value) => {
                                                if (!value) {
                                                    return `Enter the total cost for this product`
                                                }
                                            }}>
                                            {(props) => (
                                                <OutlinedFormInput
                                                    {...props.input}
                                                    label="Total Cost on Invoice"
                                                    showError={true}
                                                    // placeholder="Number of Units Purchased From the Supplier"
                                                    inpuType="number"
                                                    name={props.input.name}
                                                    value={props.input.value}
                                                    onChange={(e) => {
                                                        const numericValue = parseNumberForDB(e.target.value, false);
                                                        // console.log('numeric value', numericValue)
                                                        props.input.onChange(numericValue);
                                                    }}
                                                    error={props.meta.error}
                                                    touched={props.meta.touched}
                                                    onBlur={(e) => {
                                                        const value = props.input.value;
                                                        // console.log('value', value);
                                                        const formattedValue = onBlurFormatNumber(value, 0);
                                                        props.input.onChange(formattedValue);
                                                        // console.log('inputValue', value)
                                                        props.input.onBlur(e);
                                                    }}
                                                    maxLength={21}
                                                    isCurrency={true}
                                                    unitPlaceHolder={'₹'}
                                                    unitPosition={"left"}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className={styles.footerContainer}>
                                        {/* <div className={styles.leftContainer}>
                                           <MeritoButton btnText={'Delete'} type="destructive-ghost" onClick={() => onClose()} onlyIcon={true} icon={<DeleteIcon />} />
                                        </div> */}
                                        <div className={styles.rightContainer}>
                                            {isMobile ? null : <MeritoButton btnText="Cancel" type="tertiary" onClick={() => onClose()} />}
                                            <MeritoButton disabled={pristine || hasValidationErrors} btnText={"Add Product"} type="primary-1" onClick={() => {
                                                handleSubmit();
                                            }} />
                                        </div>

                                    </div>
                                </form>
                            )
                        }}
                    />

                </div>
            </Modal>
        </>
    );
}

export default NewProductForm;